<template>
  <div class="contacts">
    <h2 class="contacts__header kds-typography-center">
      {{ $t('b2b__landing_page__contacts__title') }}
    </h2>
    <div class="contacts__text kds-typography-center">
      {{ $t('b2b__landing_page__contacts__description') }}
    </div>
    <GenericSupportModal>
      <template #trigger="{ open }">
        <BaseButton
          variant="outlined"
          class="contacts__cta"
          :text="$t('b2b__landing_page__generic__contact_btn__title')"
          @click="open()"
        />
      </template>
    </GenericSupportModal>
  </div>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import GenericSupportModal from '@us/app/components/GenericSupportModal.vue'
</script>

<style lang="scss" scoped>
.contacts {
  background-color: $kds-color-background-base;
  padding: 30px $kds-space-3x;

  &__header {
    @include kds-typography-display-small;
    margin-bottom: $kds-space-3x;
  }

  &__text {
    @include kds-typography-paragraph-large;
    font-weight: $kds-typography-font-weight-regular;
  }

  &__cta {
    width: fit-content;
    margin: 31px auto 0;
  }
}

.contacts {
  @include media-up(sm) {
    padding: $kds-space-6x $kds-space-3x;
  }

  @include media-up(md) {
    padding: 72px 82px;
  }

  @include media-up(xl) {
    padding: $kds-space-12x 82px;
  }

  @include media-up(xxl) {
    margin: 0 auto;
    width: 1200px;
  }

  &__header {
    @include media-up(md) {
      @include kds-typography-display-medium;
      margin-bottom: $kds-space-3x;
    }

    @include media-up(xl) {
      @include kds-typography-display-large;
    }

    font-weight: $kds-typography-font-weight-medium;
  }

  &__text {
    @include media-up(md) {
      @include kds-typography-display-small;
    }
    font-weight: $kds-typography-font-weight-regular;
  }

  &__cta {
    @include media-up(md) {
      margin-top: $kds-space-4x;
    }
  }
}
</style>
